/**
 * Omnipress WooCommerce JS
 */

(function () {

  const BODY_CLASS = "is-search-modal-open";
  const BODY_CLASS_OUT = "is-search-modal-closing";
  const TRIGGER_SELECTOR = ".search-modal-trigger";
  const MODAL_SELECTOR = ".search-modal";

  // Cache DOM references
  const body = document.body;
  const modal = document.querySelector(MODAL_SELECTOR);
  const triggers = document.querySelectorAll(TRIGGER_SELECTOR);

  // ── Open ──────────────────────────────────────────────────────────────────
  function openModal() {
    body.classList.add(BODY_CLASS);
    body.classList.remove(BODY_CLASS_OUT);
    modal.setAttribute("aria-hidden", "false");
    modal.setAttribute("aria-modal", "true");

    // Focus first focusable element inside modal
    const focusable = modal.querySelector(
      'input, button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) focusable.focus();
  }

  // ── Close ─────────────────────────────────────────────────────────────────
  function closeModal() {
    body.classList.remove(BODY_CLASS);
    body.classList.add(BODY_CLASS_OUT);
    modal.setAttribute("aria-hidden", "true");
    modal.removeAttribute("aria-modal");
  }

  // ── Event: Trigger click ──────────────────────────────────────────────────
  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      openModal();
    });
  });

  // ── Event: Close button inside modal ─────────────────────────────────────
  modal.addEventListener("click", function (e) {
    const closeBtn = e.target.closest("[data-search-close]");
    if (closeBtn) closeModal();
  });

  // ── Event: Click on backdrop (outside modal content) ─────────────────────
  modal.addEventListener("click", function (e) {
    if (e.target === modal) closeModal();
  });

  // ── Event: Escape key ────────────────────────────────────────────────────
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && body.classList.contains(BODY_CLASS)) {
      closeModal();
    }
  });

})();
